import Dialog from 'ui/organisms/dialogs/Dialog/Dialog';
import Icon from 'ui/atoms/Icon/Icon';
import TemplateCard from 'core/modules/components/cards/TemplateCard/TemplateCard';
import NoItems from 'core/modules/components/general/NoItems';
import MosaicList from 'core/modules/components/lists/components/MosaicList';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import useDialogLemonadeTemplates from './useDialogLemonadeTemplates';

const DialogLemonadeTemplates = ({ t, open, onClose, onSubmit, disabledTemplates = [], templates = [], isQuizzWithIA = false }) => {
  const { types, selectedType, availableOptions, selectedTemplate, setAvailableOptions, setSelectedTemplate, setSelectedType } =
    useDialogLemonadeTemplates({
      open,
      disabledTemplates,
      templates,
    });

  return (
    <Dialog
      title={isQuizzWithIA ? t('Select an AI template') : t('Select a template')}
      isOpen={open}
      hasFooterBackground={true}
      onClose={onClose}
      className="dialog-lemonade-templates"
      size="xl"
      hasSeparator={true}
      isDisabledSuccess={!selectedTemplate}
      buttonTextSuccess={t('actions:Continue')}
      buttonTextCancel={t('actions:Cancel')}
      onSuccess={() => {
        onSubmit(selectedTemplate);
      }}
      onCancel={onClose}
    >
      <div>
        <div className="dialog-lemonade-templates__wrapper">
          <div className="dialog-lemonade-templates__columns">
            <div className="dialog-lemonade-templates__left-column">
              <div className="dialog-lemonade-templates__types">
                {types.map((type) => {
                  return (
                    <div
                      key={type.id}
                      className={`dialog-lemonade-templates__type dialog-lemonade-templates__type--${type.id === selectedType ? 'selected' : 'default'}`}
                      onClick={() => {
                        setSelectedType(type.id);
                        setAvailableOptions(type.children);
                      }}
                    >
                      <div className="dialog-lemonade-templates__type-icon">
                        <Icon color={type.id === selectedType ? 'primary' : 'default'} name={type.id} />
                      </div>
                      <div className="dialog-lemonade-templates__type-name">{t(`lemonade:${type.name}`)}</div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="dialog-lemonade-templates__right-column">
              <div className="dialog-lemonade-templates__list">
                {availableOptions.length ? (
                  <MosaicList
                    columns={2}
                    items={availableOptions.map((template) => {
                      return (
                        <TemplateCard
                          key={template.guid}
                          guid={template.guid}
                          title={t(`lemonade:${template.title}`)}
                          image={template.image}
                          // description={template.description}
                          onSelect={(guid) => setSelectedTemplate(guid)}
                          selected={selectedTemplate === template.guid}
                        />
                      );
                    })}
                  />
                ) : (
                  <NoItems imageId="noQuestions" />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

DialogLemonadeTemplates.propTypes = {
  disabledTemplates: PropTypes.array,
  isQuizzWithIA: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  open: PropTypes.bool,
  t: PropTypes.func,
  templates: PropTypes.array,
};

DialogLemonadeTemplates.defaultProps = {
  disabledTemplates: [],
  isQuizzWithIA: false,
  templates: [],
};

export default withTranslation(['template', 'actions', 'lemonade'])(DialogLemonadeTemplates);
